export enum SimulateStatus {
  NONE = 'NONE',
  IN_PROGRESS = 'IN_PROGRESS',
  MAX_CAPACITY = 'MAX_CAPACITY',
}
